<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">Сделки</v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="teal" class="white--text" :disabled="!selectedOrders.length" @click="exportToXls">
                            {{ $t('exportXLS') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <div class="py-3"></div>

                <order-filters @filter-change="filterChange"></order-filters>

                <div class="py-3"></div>
                <v-card>
                    <orders-table :filters="filters" @load-error="onDataLoadError"></orders-table>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { OrdersTable } from '../../../components/data-tables';
import { ExportService } from '../../../services';
import { OrderFilters } from '../../../components/filters';
import { MixinTableLoadSnack } from '../../../mixins';

export default {
    name: 'Orders',
    components: {
        OrdersTable,
        OrderFilters,
    },
    mixins: [MixinTableLoadSnack],
    data() {
        return {
            metaUrl: '/orders',
            filters: {},
        }
    },
    computed: {
        selectedOrders() {
            return this.$store.state.selectedOrders;
        },
    },
    methods: {
        filterChange(filters) {
            this.filters = filters;
        },
        exportToXls() {
            ExportService.orders(this.selectedOrders.map(item => item.id));
            this.$store.commit('setSelectedOrders', []);
        },
    },
    beforeDestroy() {
        this.$store.commit('setSelectedOrders', []);
    }
}
</script>

<style scoped></style>
